export default "__VITE_ASSET__DxKYK$Zr__"